import Backdrop from "@mui/material/Backdrop";
import { useSelector } from "react-redux";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

import { RootState } from "../../store/store";

export default function Spinner() {
    const isLoading = useSelector((state: RootState) => state.ui.isLoading);

    return (
        <div>
            <Backdrop
                sx={theme => ({
                    color: "#fff",
                    zIndex: theme.zIndex.drawer + 1,
                })}
                open={isLoading}
            >
                <DotLottieReact
                    src='/animations/spinner.lottie'
                    loop
                    autoplay
                    className='lottie-animation'
                />
            </Backdrop>
        </div>
    );
}
